import axios from "axios";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import { useEffect, useMemo, useState } from "react";

const SubscriptionList = () => {
  const [subscriptions, setSubscriptions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");

  const fetchSubscriptions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/subscriptions`
      );
      setSubscriptions(response.data);
    } catch (error) {
      console.error("Error fetching subscriptions", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const sortedSubscriptions = useMemo(() => {
    return [...subscriptions].sort((a, b) => {
      const dateA = new Date(a.created_at).getTime();
      const dateB = new Date(b.created_at).getTime();
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });
  }, [subscriptions, sortOrder]);

  const handleSortByDate = () => {
    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  useEffect(() => {
    return () => {
      const el = document.getElementById("subscriptionOffcanvas");
      if (el) {
        const instance = Offcanvas.getInstance(el);
        instance?.dispose();
      }

      document
        .querySelectorAll(".offcanvas-backdrop")
        .forEach((b) => b.remove());
    };
  }, []);

  const SortIcon = ({ order }: { order: "asc" | "desc" }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      width="16"
      height="16"
      style={{
        marginLeft: "6px",
        transition: "transform 0.2s ease",
        transform: order === "asc" ? "rotate(180deg)" : "rotate(0deg)",
      }}
    >
      <path d="M130.4 268.2C135.4 280.2 147 288 160 288L480 288C492.9 288 504.6 280.2 509.6 268.2C514.6 256.2 511.8 242.5 502.7 233.3L342.7 73.3C330.2 60.8 309.9 60.8 297.4 73.3L137.4 233.3C128.2 242.5 125.5 256.2 130.5 268.2zM130.4 371.7C125.4 383.7 128.2 397.4 137.3 406.6L297.3 566.6C309.8 579.1 330.1 579.1 342.6 566.6L502.6 406.6C511.8 397.4 514.5 383.7 509.5 371.7C504.5 359.7 492.9 352 480 352L160 352C147.1 352 135.4 359.8 130.4 371.8z" />
    </svg>
  );

  return (
    <section>
      <div className="td_height_120 td_height_lg_40" />
      <div className="td_height_30" />
      <div className="container">
        <h2 className="text-center mb-4">List of Subscriptions</h2>

        <div style={{ overflowX: "auto" }}>
          <table width="100%" border={1} cellPadding={10}>
            <thead>
              <tr>
                <th>SN</th>
                <th>Email</th>
                <th>Status</th>

                <th
                  onClick={handleSortByDate}
                  style={{ cursor: "pointer", userSelect: "none" }}
                >
                  Applied At <SortIcon order={sortOrder} />
                </th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={8} align="center">
                    Loading...
                  </td>
                </tr>
              ) : sortedSubscriptions.length === 0 ? (
                <tr>
                  <td colSpan={8} align="center">
                    No subscriptions found
                  </td>
                </tr>
              ) : (
                sortedSubscriptions.map((app, index) => (
                  <tr key={app.id}>
                    <td>{index + 1}</td>
                    <td>{app.email}</td>
                    <td>{app.is_active ? "Active" : "Inactive"}</td>
                    <td>{new Date(app.created_at).toLocaleString()}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>{" "}
    </section>
  );
};

export default SubscriptionList;
